/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Discord_Merge_FailedInputs */



/**
* | output |
* | --- |
* | "Failed to merge accounts. Please try again." |
*
* @param {Profile_Discord_Merge_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const profile_discord_merge_failed = /** @type {((inputs?: Profile_Discord_Merge_FailedInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Discord_Merge_FailedInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Échec de la fusion des comptes. Veuillez réessayer.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Error al fusionar cuentas. Por favor, intente de nuevo.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Falha ao mesclar contas. Por favor, tente novamente.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Unione account fallita. Riprova.")
	return /** @type {LocalizedString} */ ("Failed to merge accounts. Please try again.")
});